import {
  ArrowLeft01Icon,
  ArrowRight01Icon,
  BubbleChatQuestionIcon,
  GitBranchIcon,
} from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import cn from 'classnames';
import { FormTypes } from 'constants/forms';
import { useSearchParams } from 'react-router-dom';

export const SIDEBAR_COLLAPSED_KEY = 'questionnaire-sidebar-collapsed';

const FORM_LABEL_BY_TYPE = {
  [FormTypes.REFEREE]: 'Referee form',
  [FormTypes.CANDIDATE]: 'Candidate form',
  [FormTypes.QUESTIONNAIRE]: 'Questionnaire',
};

const QuestionnaireSideBar = ({ form, isCollapsed, onToggleCollapsed }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeItem = searchParams.get('tab') || 'questionnaire_questions';
  const showIconsOnly = isCollapsed ?? false;

  const formLabel = FORM_LABEL_BY_TYPE[form?.type] ?? 'Referee form';

  const toggleCollapsed = () => {
    onToggleCollapsed?.(!showIconsOnly);
  };

  const refereeNavItems = [
    {
      id: 'questionnaire_questions',
      label: 'Questions',
      icon: BubbleChatQuestionIcon,
      count: form?.fields?.length || 0,
      onClick: () => {
        setSearchParams({ tab: 'questionnaire_questions' });
      },
    },
    {
      id: 'logic_jumps',
      label: 'Logic jumps',
      icon: GitBranchIcon,
      count: form?.logic_jumps?.length || 0,
      onClick: () => {
        setSearchParams({ tab: 'logic_jumps' });
      },
    },
  ];

  return (
    <aside
      className={cn(
        'fixed left-0 top-header bottom-0 flex flex-col bg-neutral-1 border-r border-neutral-4 overflow-y-auto z-40 transition-[width] duration-200',
        showIconsOnly ? 'w-20 p-2' : 'w-sidebar p-4',
        'max-[1140px]:w-20 max-[1140px]:p-2',
      )}
      title={formLabel}>
      <section
        className={cn(
          'flex flex-col flex-1 min-h-0 gap-6',
          showIconsOnly && 'gap-4',
          'max-[1140px]:gap-4',
        )}
        title={formLabel}>
        <div className="flex flex-col gap-2">
          {refereeNavItems.map(item => {
            const isActive = activeItem === item.id;
            return (
              <div
                key={item.label}
                title={item.label}
                className={cn(
                  'flex items-center cursor-pointer hover:bg-neutral-3 rounded-2xl p-4 transition-all duration-300',
                  showIconsOnly ? 'justify-center p-3' : 'justify-between',
                  'max-[1140px]:justify-center max-[1140px]:p-3',
                  isActive && 'bg-neutral-3',
                )}
                onClick={item.onClick}>
                <div
                  className={cn(
                    'flex items-center',
                    showIconsOnly ? 'gap-0' : 'gap-2 max-[1140px]:gap-0',
                  )}>
                  <HugeiconsIcon
                    icon={item.icon}
                    size="20"
                    className={isActive ? 'text-neutral-7' : 'text-neutral-6'}
                  />
                  <span
                    className={cn(
                      'text-xl font-regular',
                      showIconsOnly ? 'hidden' : 'max-[1140px]:hidden',
                      isActive ? 'text-neutral-7 font-medium' : 'text-neutral-6',
                    )}>
                    {item.label}
                  </span>
                </div>
                <span
                  className={cn(
                    'flex items-center justify-center w-10 h-10 text-xl rounded-full border',
                    showIconsOnly ? 'hidden' : 'max-[1140px]:hidden',
                    isActive
                      ? 'text-white bg-primary-4 border-primary-4'
                      : 'text-neutral-6 bg-neutral-3 border-neutral-4',
                  )}>
                  {item.count}
                </span>
              </div>
            );
          })}
        </div>

        <div
          className={cn(
            'mt-auto flex justify-end',
            showIconsOnly ? 'justify-center' : 'justify-end',
          )}>
          <div
            role="button"
            aria-label="Toggle sidebar"
            aria-expanded={!showIconsOnly}
            aria-controls="questionnaire-sidebar"
            onClick={toggleCollapsed}
            title={showIconsOnly ? 'Expand sidebar' : 'Collapse sidebar'}
            className={cn(
              'flex items-center bg-neutral-2 border border-neutral-4 shadow-md rounded-2xl p-2 hover:bg-neutral-3 text-neutral-6 hover:text-neutral-7 transition-colors w-max align-self-end',
              showIconsOnly
                ? 'justify-center p-2'
                : 'justify-start max-[1140px]:justify-center max-[1140px]:p-2',
            )}>
            <HugeiconsIcon
              icon={showIconsOnly ? ArrowRight01Icon : ArrowLeft01Icon}
              size="20"
              strokeWidth="2"
            />
          </div>
        </div>
      </section>
    </aside>
  );
};

export default QuestionnaireSideBar;
